import Row from "@Containers/components/Row";
import Translation from "@Translation/components/Translation";
import LanguageSwitcher from "@Header/components/LanguageSwitcher/LanguageSwitcher";
import React from "react";
import useIsDesktop from "@Hooks/selector/useIsDesktop";
import TravelingDotComLogoMark from "@Generic/logotypes/TravelingDotComLogoMark";

type CookieTitleProps = {}

function CookieTitle(props: CookieTitleProps) {
    const isDesktop = useIsDesktop()
    return (
        <Row justify center>
            <Row center>
                <TravelingDotComLogoMark
                    height={28}
                    width={46}
                />
                <span className="gb--cookie-dialog-title">
                        <Translation translationKey="cookie.notice.privacy_settings"/>
                </span>
            </Row>
            {isDesktop && (
                <ul className="gb--menu gb--menu__nav gb--row gb--row-middle gb--row-end">
                    <LanguageSwitcher/>
                </ul>
            )}
        </Row>
    );
}

export default CookieTitle;